export default "__VITE_ASSET__Bk3bAkT0__"